import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DivisionSuppTickets = () => {
  return (
    <SettingsMetaData propertyName={"Division_Support_Tickets"} viewPropertyName={"Division"} />
  );
};
export default DivisionSuppTickets;